import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './SiteNav.css';

// The single site-wide navigation, used on every page.
const SiteNav = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // "Projets" points at the verticals section on the landing page.
  // If we're already on the landing page, smooth-scroll; otherwise navigate
  // home with the #ventures hash and let the landing page scroll to it.
  const goToProjects = () => {
    if (location.pathname === '/') {
      document.getElementById('ventures')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#ventures');
    }
  };

  return (
    <nav className={`nav ${scrolled ? 'nav-scrolled' : ''}`} data-testid="site-nav">
      <div className="nav-container">
        <Link to="/" className="nav-logo" data-testid="nav-logo">
          <img src="/bcg-horiz-logo.png" alt="Brands Capital Group" />
        </Link>
        <div className="nav-links">
          <a onClick={goToProjects}>{t('nav.projects')}</a>
          <Link to="/incubator" className={location.pathname.startsWith('/incubator') ? 'active' : ''}>
            BCG Incubator
          </Link>
          <Link to="/careers" className={location.pathname.startsWith('/careers') ? 'active' : ''}>
            {t('nav.careers')}
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default SiteNav;
